module.exports = __webpack_public_path__ + "static/media/blank_footer.1a8b378e.png";